import { RoleLiteModel } from 'api-hooks/role';
import { Expose, Type } from 'class-transformer';
import { CommonParamInput } from 'common/repositories/common.model';

export class ApprovalMasterDetailsModel {
  id: string;

  @Type(() => RoleLiteModel)
  role: RoleLiteModel;

  @Type(() => Number)
  order: number;
}

export class ApprovalMasterModel {
  id: string;
  model: string;

  @Expose({ name: 'approval_details' })
  @Type(() => ApprovalMasterDetailsModel)
  approvalDetails: ApprovalMasterDetailsModel[];
}

export class ApprovalMasterLiteModel {
  id: string;
  model: string;

  @Expose({ name: 'approval_details' })
  @Type(() => ApprovalMasterDetailsModel)
  approvalDetails: ApprovalMasterDetailsModel[];
}

// Input
export type getApprovalMastersInput = {
  params: CommonParamInput;
};

export type getApprovalMasterInput = {
  id: string;
};

export type ApprovalMasterDetailsMutation = {
  roleId: string;
  order: number;
};

export type ApprovalMasterMutationInput = {
  model: string;
  approvalDetails: ApprovalMasterDetailsMutation[];
};

export type ApprovalMasterUpdateInput = {
  approvalId: string;
  body: ApprovalMasterMutationInput;
};

export type ApprovalMasterDeleteInput = {
  approvalId: string;
};
